/**
*
* Map
*
*/

import React from 'react';


import throttle from 'helpers/throttle';

import { MAPBOX_TOKEN } from 'configs';

import isJson from 'helpers/isJson';


import MapWrapper from './styles/MapWrapper';


class Map extends React.PureComponent { // eslint-disable-line react/prefer-stateless-function

  constructor() {
    super();

    this.thisMap = React.createRef();
    
    this._isMounted = false;

    this.onViewportChange = this.onViewportChange.bind(this);

    this.state = {
      viewport: {
        latitude: 37.7577,
        longitude: -122.4376,
        zoom: 12
      }
    };
  }
  



  onViewportChange(viewport, hasTimeout) {

    if (!this._isMounted || !this.thisMap || !this.thisMap.current) return;

    const thisViewport = viewport ? { ...this.state.viewport, ...viewport } : this.state.viewport;

    if (hasTimeout) return setTimeout(() => {
      if (!this._isMounted || !this.thisMap) return;
      this.setState({
        viewport: thisViewport,
        width: this.thisMap.current.parentNode.getBoundingClientRect().width,
        height: this.thisMap.current.parentNode.getBoundingClientRect().height
      });
    }, 300);

    this.setState({
      viewport: thisViewport,
      width: this.thisMap.current.parentNode.getBoundingClientRect().width,
      height: this.thisMap.current.parentNode.getBoundingClientRect().height
    });


  };

  componentDidMount() {

    this._isMounted = true;

    const {
      frameRef
    } = this.props;

    const frameWindow = frameRef && document.querySelector(frameRef) && document.querySelector(frameRef).contentWindow ? document.querySelector(frameRef).contentWindow : window;


    const viewport = {};

    if (this.props.viewport) {

      const parseViewport = isJson(this.props.viewport);

      viewport.latitude = parseViewport.latitude;
      viewport.longitude = parseViewport.longitude;

    }

    this.setState(viewport);





    frameWindow.addEventListener('resize', throttle(this.onViewportChange, 17));    
   


  }
  
  componentDidUpdate(prevProps, prevState) {
    const { windowWidth } = this.props;

    if (prevProps.windowWidth !== windowWidth) return this.onViewportChange(null, true);

    let latitude;
    let longitude;

    if (this.props.viewport) {

      const parseViewport = isJson(this.props.viewport);
      latitude = parseViewport.latitude;
      longitude = parseViewport.longitude;

    }


    if (!latitude || !longitude) return;

    if (
      latitude !== prevState.viewport.latitude ||
      longitude !== prevState.viewport.longitude
    ) {
      const viewport = {
        latitude: latitude,
        longitude: longitude
      };
      this.onViewportChange(viewport);
    }


  }


  componentWillUnmount() {
    this._isMounted = false;

    const {
      frameRef
    } = this.props;

    const frameWindow = frameRef && document.querySelector(frameRef) && document.querySelector(frameRef).contentWindow ? document.querySelector(frameRef).contentWindow : window;

    frameWindow.removeEventListener('resize', throttle(this.onViewportChange, 17));

  }


  render() {
    const { width, height, viewport } = this.state;


    const {
      latitude,
      longitude,
      zoom
    } = viewport;

    return(
      <MapWrapper
        ref={this.thisMap}
        theme={this.props.theme}
        width={width}
        height={height}
        background={`https://api.mapbox.com/styles/v1/mapbox/light-v10/static/${longitude},${latitude},${zoom},0/${width > 800 ? '1280x1280' : '800x800'}?access_token=${MAPBOX_TOKEN}`}
      >

        {/* <img src={`https://api.mapbox.com/styles/v1/mapbox/light-v10/static/${longitude},${latitude},${zoom},0/300x200?access_token=${MAPBOX_TOKEN}`} />
         */}
      </MapWrapper>
    );
  }
}

export default Map;
